import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type EditProgramPayload = {
  programId: string
  hourlyLimit?: number | null
  dailyLimit?: number | null
  monthlyLimit?: number | null
  perClientIdLimit?: number | null
  concurrentLimit?: number | null
}

export function useEdit() {
  return useMutation<unknown, unknown, EditProgramPayload>({
    mutationFn: async ({ programId, ...values }: EditProgramPayload) => {
      const { data } = await apiClient.put<EditProgramPayload>(
        `/int/v3/programs/${programId}/volume-limits`,
        values
      )
      return data
    },
  })
}
